import React, { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';
import { formatDateMoment } from '../../../../../util/core/DateHelper'
import 'moment/locale/pt-br';
import DatePicker, { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import br from 'date-fns/locale/pt-BR';
import './DatePeriod.css';
registerLocale('br', br);

function DatePeriodField(props) {
    const [dateValues, setDateValues] = useState({
        [props.name_start]: props.value ? moment(props.value).toDate() : null,
        [props.name_end]: props.valueEnd ? moment(props.valueEnd).toDate() : null,
    });

    let className = 'form-control';

    if (props.error) {
        className += ' error';
    }

    const handleDateChange = (name, element) => {
      
        element !== null && moment(element).isValid()       

        const updatedValues = {
            ...dateValues,
            [name]: element,
        };

        setDateValues(updatedValues);

        const target = {
            name: props.name,
            name_start: props.name_start,
            name_end: props.name_end,
            type: 'date_period',
            value_start: formatDateMoment(updatedValues[props.name_start], 'YYYY-MM-DD'),
            value_end: formatDateMoment(updatedValues[props.name_end], 'YYYY-MM-DD')
        };
        props.onChange({ target });
    };

    if(props.error){
        className+=" is-invalid";
    }

    useEffect(() => {

        const startDateValue = props.value ? moment(props.value).toDate() : null;
        const endDateValue = props.valueEnd ? moment(props.valueEnd).toDate() : null;

        setDateValues({
            [props.name_start]: startDateValue,
            [props.name_end]: endDateValue,
        });
    }, [props.value, props.valueEnd]);


    return (
        <div className={`date-period-container ${props.containerClassName}`}>
            <>
                <label htmlFor={props.name_start}>
                    {props.label}
                </label>
                {props.required && (
                    <span className="required"> *</span>
                )}
                <div className="date-row">
                    <div className="date-label-input">
                        <DatePicker
                            id={'id_' + props.name_start}
                            name={props.name_start}
                            selected={dateValues[props.name_start]}
                            readOnly={props.readOnly}
                            onChange={(date) => handleDateChange(props.name_start, date)}
                            locale="br"
                            dateFormat="dd/MM/yyyy"
                            strictParsing
                            className={`${className} date-input`}
                            autoFocus={props.autoFocus ? true : false}
                        />
                    </div>
                    <label htmlFor={props.name_end}>
                        até
                    </label>
                    <div className="date-label-input">
                        <DatePicker
                            id={'id_' + props.name_end}
                            name={props.name_end}
                            selected={dateValues[props.name_end]}
                            readOnly={props.readOnly}
                            onChange={(date) => handleDateChange(props.name_end, date)}
                            locale="br"
                            dateFormat="dd/MM/yyyy"
                            strictParsing
                            className={`${className} date-input`}
                            autoFocus={props.autoFocus ? false : false}
                        />
                    </div>
                </div>
            </>

            {props.error && (
                <span
                    className="error invalid-feedback is-invalid">
                    {props.error}
                </span>
            )}
        </div>
    );
}

export default DatePeriodField;